module.exports = __webpack_public_path__ + "img/2024-20.1e7b6ab5.jpg";